<div *ngIf="tenantId$ | async as tenantId">
    <div *ngIf="plantId$ | async as plantId">
        <anms-plant-info [plantId]="plantId"></anms-plant-info>
        <anms-device-list-view [tenantId]="tenantId" [plantId]="plantId"></anms-device-list-view>
    </div>
</div>